import Vue from 'vue'
import App from './App.vue'
import routerManager from './router/index-manager.js'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/styles/base.less'
import './assets/styles/global.less'

import SelectModal from './components/SelectModal/plugin.js'
import FilterFieldModal from './components/FilterFieldModal/plugin.js'
import { HttpClient } from './utils/service.js'
import drag from './utils/drag.js'

Vue.config.productionTip = false

// 使用Element UI
Vue.use(ElementUI)
// 使用SelectModal插件
Vue.use(SelectModal)
Vue.use(FilterFieldModal)
Vue.directive('drag', drag)

Vue.prototype.$service = new HttpClient({ baseURL: '/valuation' })
Vue.prototype.$serviceAdmin = new HttpClient({ baseURL: '/admin' })

let re = router

if (process.env.type === 'manager') {
  re = routerManager
}
new Vue({
  router: re,
  store,
  render: h => h(App)
}).$mount('#app')
